import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import UpdateableLabelComponent from '../Utility/Component/Observable/UpdateableLabelComponent';
import ComponentBase from '../Utility/ComponentBase';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import BetManager from './BetManager';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Class designed to bind an updateable label to configuration
 * from a betManager instance.
 */
@cc._decorator.ccclass
@cc._decorator.requireComponent(UpdateableLabelComponent)
export default class BetManagerUpdateableLabelComponent extends ComponentBase
{
    /**
     * BetManager to pull configurations from.
     */
    @property(InjectableComponent)
    protected betManagerRef: InjectableComponent<BetManager> = new InjectableComponent<BetManager>();

    /**
     * This updateable label.
     */
    protected updateableLabel: UpdateableLabelComponent = null;

    /** @hidden */
    protected setContexts(): void
    {
        this.betManagerRef.SetContext(BetManager);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.updateableLabel = this.getComponent(UpdateableLabelComponent);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.betManagerRef.Value.IsCashObservable.OnChanged(() => this.updateProperties());
    }

    /** @hidden */
    protected firstUpdate(dt: number): void
    {
        super.firstUpdate(dt);

        this.updateProperties();
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (this.betManagerRef.HasValue() && this.betManagerRef.Value.IsCashObservable) {
            this.betManagerRef.Value.IsCashObservable.OffChanged(() => this.updateProperties());
        }
    }

    /** Update properties of label from betManager instance. */
    private updateProperties = (): void =>
    {
        if (!this.betManagerRef.Value)
        {
            CLog.error("No BetManager configured.", this, LogTypes.Initialization);
            return;
        }

        let isCash: boolean = this.betManagerRef.Value.IsCash;

        this.updateableLabel.IsLocalized = isCash;
        this.updateableLabel.HideDecimalComponent = !isCash;
    }
}
